import { Typography, Spacer } from '@telus-uds/components-web'
import { LegalTextRenderer } from '../../../utils/text/TextRenderer'
import ExtraDetailsSection from './ExtraDetailsSection'
import ProductDetailsSection from './ProductDetailsSection'
import { DEFAULTS, PlanSectionDetailFields } from './PlanSection'
import DetailsSection from './DetailsSection'
import { renderExpandCollapse } from './SectionRenderer'
import { DetailsSectionProps } from './DetailsSection'

type ProductDetailsProps = {
  isMobile: boolean
  collapseButtonText: string
  expandButtonText: string
  detailsSection?: DetailsSectionProps[]
  extraDetailsSection?: PlanSectionDetailFields[]
}

const ProductDetails = ({
  isMobile,
  collapseButtonText,
  expandButtonText,
  detailsSection,
  extraDetailsSection,
}: ProductDetailsProps) => {
  const { COLORS, IMAGE_LEFT_MARGIN } = DEFAULTS
  const [firstSection, ...expandDetailsSection] = detailsSection || []
  const { sectionTitle: firstTitle, sectionDetails: firstDetails } = firstSection || {}
  return (
    <div>
      {detailsSection &&
        (!isMobile ? (
          detailsSection.map((section, idx) => {
            return <DetailsSection key={idx} {...section} idx={idx} />
          })
        ) : (
          <div>
            {firstTitle && (
              <div>
                <Typography block variant={{ size: 'h4' }} tokens={{ color: COLORS.SHUTTLE_GREY }}>
                  <LegalTextRenderer>{firstTitle}</LegalTextRenderer>
                </Typography>
                <Spacer space={2} />
              </div>
            )}
            {firstDetails &&
              firstDetails.map((sectionDetail, idx) => {
                return (
                  <div key={idx}>
                    <ProductDetailsSection sectionDetail={sectionDetail} IMAGE_LEFT_MARGIN={IMAGE_LEFT_MARGIN} />
                  </div>
                )
              })}
            {(extraDetailsSection || expandDetailsSection.length > 0) &&
              renderExpandCollapse(
                collapseButtonText,
                expandButtonText,
                expandDetailsSection,
                IMAGE_LEFT_MARGIN,
                extraDetailsSection,
                COLORS.SHUTTLE_GREY
              )}
          </div>
        ))}
      {!isMobile && extraDetailsSection && <ExtraDetailsSection extraDetailsSection={extraDetailsSection} />}
    </div>
  )
}

export default ProductDetails
